import React from 'react';
import { isMobile } from 'react-device-detect';

const bannerTitleClick = (props) => {
    //window.location.href = "/";
}

export default (props) => (
    <div id="pageTop">
        <div className="banner">
            <div className="anueContainer">
                <div className="sizeBox">
                    <a href="/FundSpec/OpenAcct/" target="_blank" rel="noopener noreferrer">
                        <h1 onClick={() => { bannerTitleClick(props) }} className="title" alt="【好日子】─ anuefund鉅亨買基金"><span data-aos="flip-right" ></span></h1>
                    </a>
                </div>
            </div>
        </div>
        <div className="secContent bg_s featureSection" style={{paddingTop:"0px"}}>
            <div className="anueContainer bg_anueContainer">
                <div style={{paddingBottom:"50px"}}>
                    <div className="titleBlock">
                        <h2 className="trialTitle" data-aos="flip-up" style={{color: "#0f91d8"}}><i class="fa fa-thumbs-up" aria-hidden="true"></i> 好觀念</h2>
                        <h2 className="trialTitle" data-aos="flip-up" style={{ color: "black" , fontSize:"20px"}}>親子理財三撇步</h2>
                    </div>
                </div>
                <div className="featureBlock">
                    <div className="divisionBlock" data-aos="fade-right" style={{margin:"0px auto", width: "370px"}}>
                        <div className="featureBox2" style={{background:"url(./assets/imgs/Good-1.png) no-repeat", width: "100%", maxWidth:"370px"}}>
                            <span style={{fontSize:"36px",color:"#0f91d8"}}>儘早開始</span><br></br><br></br>
                            <span style={{fontSize:"20px"}}>贏在起跑點，未來更有利</span>
                        </div>
                    </div>
                    <div className="divisionBlock" data-aos="fade-up" style={{margin:"0px auto", width: "370px"}}>
                        <div className="featureBox2" style={{background:"url(./assets/imgs/Good-2.png) no-repeat", width: "100%", maxWidth:"370px"}}>
                            <span style={{fontSize:"36px",color:"#0f91d8"}}>善用工具</span><br></br><br></br>
                            <span style={{fontSize:"20px"}}>慎選好產品，達標更容易</span>
                        </div>
                    </div>
                    <div className="divisionBlock" data-aos="fade-left" style={{margin:"0px auto", width: "370px"}}>
                        <div className="featureBox2" style={{background:"url(./assets/imgs/Good-3.png) no-repeat", width: "100%", maxWidth:"370px"}}>
                            <span style={{fontSize:"36px",color:"#0f91d8"}}>保持紀律</span><br></br><br></br>
                            <span style={{fontSize:"20px"}}>持續穩定投，複利更驚豔</span>
                        </div>
                    </div>
                </div>
                <div style={{margin:"0px auto"}} className="featureBlock">
                    <a href="https://www.anuefund.com/investment-article/8dc15e5d90b1bacGCtEXajRNwzKUVnd7nHIAoyppN7ai2C7gp4" target="_blank" rel="noopener noreferrer">
                        <div className="btn_child" data-aos="fade-up">孩子的第一桶金這樣存</div>
                    </a>
                </div>
            </div>
            <span class="investArrow">▲</span>
            <div class="investHr"></div>
            <div className="anueContainer bg_anueContainer">
                <div style={{paddingBottom:"50px", paddingTop: "20px"}}>
                    <div className="titleBlock">
                        <h2 className="trialTitle" data-aos="flip-up" style={{color: "#f04e28"}}><i class="fa fa-gratipay" aria-hidden="true"></i> 好產品</h2>
                        <h2 className="trialTitle" data-aos="flip-up" style={{ color: "black" , fontSize:"20px"}}>鉅亨好日子特色</h2>
                    </div>
                </div>
                <div className="featureBlock">
                    <div className="divisionBlock" data-aos="fade-right">
                        <div className="gaps">
                            <div className="featureBox featrueText">
                                <div className="tag" style={{ borderRadius: "5px", backgroundColor:"#f04e28" }}>台股好趨勢</div>
                                <h4 style={{color:"#f04e28"}}>科技題材多</h4>
                                <h4 style={{color:"#f04e28", marginBottom:"0px"}}>投資更加值</h4>
                            </div>
                        </div>
                    </div>
                    <div className="divisionBlock" data-aos="fade-up">
                        <div className="gaps">
                            <div className="featureBox featrueText">
                                <div className="tag" style={{ borderRadius: "5px", backgroundColor:"#f04e28" }}>高效增財富</div>
                                <h4 style={{color:"#f04e28"}}>單筆加定投</h4>
                                <h4 style={{color:"#f04e28", marginBottom:"0px"}}>效益更加倍</h4>
                            </div>
                        </div>
                    </div>
                    <div className="divisionBlock" data-aos="fade-left">
                        <div className="gaps">
                            <div className="featureBox featrueText">
                                <div className="tag" style={{ borderRadius: "5px", backgroundColor:"#f04e28" }}>優惠來助攻</div>
                                <h4 style={{color:"#f04e28"}}>０元手續費</h4>
                                <h4 style={{color:"#f04e28", marginBottom:"0px"}}>長期０負擔</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="featureBlock">
                    <a href="https://www.anuefund.com/investment-article/8dc167d454b0f6cLaWA90myKPPRFvMTchXuNlEdS7SxItYzvRd" target="_blank" rel="noopener noreferrer">
                        <div className="btn_compare" data-aos="fade-up">親子理財專案超級比一比</div>
                    </a>
                </div>
                <div>
                    <div className="titleBlock" style={{paddingTop: "20px"}}>
                        <h2 className="trialTitle" data-aos="flip-up" style={{color: "#ff9900"}}><i class="fa fa-line-chart" aria-hidden="true"></i> 好機制</h2>
                        <h2 className="trialTitle" data-aos="flip-up" style={{ color: "black" }}>單筆+定投 → 1+1投資超給利!</h2>
                    </div>

                    <img src="./assets/imgs/chart_250218_1.png" alt="" />
                    <br></br>
                    <img src="./assets/imgs/chart_250218_2.png" alt="" />
                    <br></br>
                    <div>
                        <span>資料來源：Bloomberg，「鉅亨買基金」整理，資料期間為1950-2025/1，採標普500指數。此資料僅為歷史數據模擬回測，不為未來投資獲利之保證，在不同指數走勢、比重與期間下，可能得到不同數據結果。</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
)